/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { SponsorTagWrapper, SponsorTagBrandLogo, SponsorTagBrandText } from './styles/cpds-sponsor-tag-style';
import { CpdsSponsorTagProps } from './typings';
import { themeStyleClass } from '../utils/cpds-utils';

const CpdsSponsorTag: React.FC<CpdsSponsorTagProps> = (props) => {
  const { domRef, exClasses = "", children, themeTypography,  ...rest } = props;
  const className = themeStyleClass('cpds-sponsor-tag', themeTypography, exClasses);

  return (
    <SponsorTagWrapper className={className} ref={domRef} {...rest}>
      {props?.brandText && <SponsorTagBrandText>{props?.brandText}</SponsorTagBrandText>}
      {props?.brandLogo && <SponsorTagBrandLogo src={props?.brandLogo} alt={props?.brandText} />}
    </SponsorTagWrapper>
  );
};

export default CpdsSponsorTag;
